import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Drawer, message, Popconfirm, Space, Table } from "antd";
import React from "react";
import { Api } from "../../../../api/configApi";
import Boton from "../../../../components/design/elementos/boton";
import { setStoreActualizarLaEstructura, store } from "../../../../store";
import FormCrearNotificacion from "./FormCrearNotificacion";

function RenderNotificaciones() {
  const [drawerCrearNotificacion, setDrawerCrearNotificacion] =
    React.useState(false);
  const [notificacionActual, setNotificacionActual] = React.useState(null);
  function eliminarNotificacion(not) {
    Api(
      "Cuentas",
      "DeleteNotificacion",
      {
        _id: store.cuentaactiva,
      },
      {
        notificacion: not._id,
      }
    ).then((res) => {
      if (res.success) {
        message.success("Notificación eliminada");
        setStoreActualizarLaEstructura();
      } else {
        message.error("Algo no salio bien");
      }
    });
  }

  const columns = [
    {
      title: "Titulo",
      dataIndex: "titulo",
      key: "titulo",
    },
    {
      title: "Contenido",
      dataIndex: "contenido",
      key: "contenido",
    },
    {
      title: "",
      dataIndex: "opciones",
      key: "opciones",
      render: (e, not) => {
        return (
          <Space>
            <FontAwesomeIcon
              onClick={() => {
                setNotificacionActual(not);
                setDrawerCrearNotificacion(true);
              }}
              style={{ cursor: "pointer" }}
              icon={faEdit}
            />
            <Popconfirm
              title="¿Estás seguro?"
              onConfirm={() => {
                eliminarNotificacion(not);
              }}
            >
              <FontAwesomeIcon style={{ cursor: "pointer" }} icon={faTrash} />
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  return (
    <div>
      <Drawer
        title="Notificación"
        visible={drawerCrearNotificacion}
        onClose={() => {
          setDrawerCrearNotificacion(false);
        }}
      >
        <FormCrearNotificacion
          notificacionActual={notificacionActual}
          setDrawerCrearNotificacion={setDrawerCrearNotificacion}
        />
      </Drawer>
      <div style={{ textAlign: "right", marginBottom: 10 }}>
        <Boton
          onClick={() => {
            setNotificacionActual(null);
            setDrawerCrearNotificacion(true);
          }}
          texto="Crear Notificación"
        />
      </div>
      <Table dataSource={store.notificaciones} columns={columns} />
    </div>
  );
}

export default RenderNotificaciones;
